/*
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-05-08 23:02:46
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-06-14 12:38:35
 * @FilePath: \vue-privilege-routing\src\store\mutations.js
 */
export default {
    LOGIN_IN(state,token){
        state.UserToken = token;
    },
    ACCOUNT_TOKEN(state,account_token){
        state.AccountToken = account_token;
    },
    LOGIN_OUT(state){
        state.UserToken = ""
    }
}